// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"EditDocument--next-sr-only--2v8Oe72","dialog":"EditDocument--dialog--2ZBL1XB","showDocument":"EditDocument--showDocument--3NUtEC6"};